import { useInitializeDocumentFilters } from './hooks'

export const DocumentUploadInitialization = () => {
  useInitializeDocumentFilters()

  return null
}
